"use client";

import Image from "next/image";

const MentorSection = ({
  heading = "Meet your Mentor",
    //   mentorImage = "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/mentor.webp",
    mentorImage = "/images/newvs.webp",
  mentorName = "Vaibhav Sisinty",
  mentorTitle = "Founder, GrowthSchool",
  descriptionParagraph1 = "Hey Folks, I'm Vaibhav Sisinty, and I'm super excited to be your mentor for this workshop.",
  descriptionParagraph5 = "Now, I'm here to share everything I've learned with you.",
}) => {
  const linkedInCard = {
    logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/link.png",
    stats: [
      { word: "500M+", text: "Impressions" },
      { word: "600K+", text: "Followers" },
    ],
  };

  const otherCards = [
    {
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/insta.png",
      word: "1M+",
      text: "Instagram",
    },
    {
      logo: "https://d31bwppm8yl9g2.cloudfront.net/learner/gs/x.png",
      word: "150K+",
      text: "Twitter",
    },
  ];

  return (
    <div className="w-full py-10 sm:py-20 flex flex-col items-center font-ibm">
      <h2 className="text-[24px] md:text-[36px] font-medium font-mackinac mb-3 w-[90%] md:w-4/5">
        {heading}
      </h2>

      <div className="w-[90%] md:w-4/5 mx-auto flex flex-col md:flex-row gap-4 md:gap-10 items-start md:p-4">
        {/* Mentor Image and Info */}
        <div className="flex-shrink-0 w-full md:w-[40%] flex flex-col items-start border border-[#051E0166] rounded-xl p-4">
          <Image
            src={mentorImage}
            alt={mentorName}
            width={300}
            height={300}
            className="w-full h-[300px] md:w-full md:h-[452px] object-cover bg-[#F3F4F6] border border-[#051E0166] rounded-xl"
            unoptimized
          />
          <h3 className="text-xl md:text-[31px] font-medium font-figtree mt-6 mb-3">
            {mentorName}
          </h3>
          <p className="text-sm md:text-[27px] font-normal font-figtree text-gray-500 mb-5">
            {mentorTitle}
          </p>
        
        </div>

        {/* Mentor Description */}
        <div className="w-full md:w-[60%]">
          <p className="text-sm md:text-xl font-figtree leading-relaxed text-gray-800 mb-6">
            {descriptionParagraph1}
          </p>
          <p className="text-sm md:text-lg font-figtree leading-relaxed text-gray-800 mb-6">
            I've helped <strong>10M+</strong> learners master AI and LinkedIn through GrowthSchool—the platform I founded in 2021. Backed early by Sequoia (Peak XV) and Owl Ventures with <strong>$5M</strong> in funding, we've since grown <strong>400%</strong> year-on-year entirely on our own steam.
          </p>
          <p className="text-sm md:text-lg font-figtree leading-relaxed text-gray-800 mb-6">
            Before GrowthSchool, I scaled Uber from hundreds to millions of daily trips across India and LATAM, then grew Klook's India & Middle East business to <strong>$27M</strong> in just 12 months.
          </p>
          <p className="text-sm md:text-lg font-figtree leading-relaxed text-gray-800 mb-6">
            Today, I've built a following of <strong>1M+</strong> on Instagram and <strong>600K+</strong> on LinkedIn, generating over <strong>100M+</strong> views on my content. GrowthSchool was recognized as a <strong>LinkedIn Top Startup</strong> and became the <strong>first Indian EdTech</strong> to integrate Generative AI across all learning streams.
          </p>
          <p className="text-sm md:text-lg font-figtree leading-relaxed text-gray-800 mb-6">
            {descriptionParagraph5}
          </p>

          {/* Social Stats Cards */}
          <div className="flex flex-col md:flex-row gap-3 md:gap-4 mt-10">
            {/* LinkedIn Card - Combined */}
            <div className="flex items-center rounded-lg bg-white border border-[#0000004D]/30 w-full md:w-[320px]">
              <div className="w-[20%] h-[67px] bg-[#FFEBC7] flex items-center justify-center rounded-tl-lg rounded-bl-lg">
                <Image
                  src={linkedInCard.logo}
                  alt="LinkedIn Logo"
                  width={24}
                  height={24}
                  className="w-auto h-6 object-contain invert"
                  unoptimized
                />
              </div>
              <div className="flex-1 flex relative h-[67px]">
                {linkedInCard.stats.map((stat, index) => (
                  <div key={index} className="flex-1 flex flex-col justify-center p-2 relative">
                    {index > 0 && (
                      <div className="absolute left-0 top-3 bottom-3 w-px bg-[#0000004D]/30"></div>
                    )}
                    <p className="text-gray-800 text-base font-semibold">
                      {stat.word}
                    </p>
                    <p className="text-sm">{stat.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Instagram and Twitter Cards */}
            <div className="flex flex-wrap md:flex-nowrap gap-3 md:gap-4">
              {otherCards.map((card, index) => (
                <div
                  key={index}
                  className="flex items-center rounded-lg bg-white border border-[#0000004D]/30 w-[calc(50%-0.375rem)] md:w-[160px] h-[67px]"
                >
                  <div className="w-[40%] h-full bg-[#FFEBC7] flex items-center justify-center rounded-tl-lg rounded-bl-lg">
                    <Image
                      src={card.logo}
                      alt="Logo"
                      width={24}
                      height={24}
                      className="w-auto h-6 object-contain invert"
                      unoptimized
                    />
                  </div>
                  <div className="p-2">
                    <p className="text-gray-800 text-base font-semibold">
                      {card.word}
                    </p>
                    <p className="text-sm">{card.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorSection;
